<template>
  <div class="search-container">
    <input
      ref="searchInput"
      type="text"
      name="search"
      :placeholder="placeholder"
      :value="searchString"
      tabindex="0"
      autocomplete="off"
      maxlength="300"
      @keyup="change"
    >
  </div>
</template>

<script>
  import debounce from 'lodash-es/debounce'
  import querystring from 'querystring'

  export default {
    props: {
      resultsPageVisible: {
        type: Boolean,
        required: true
      },
      placeholder: {
        type: String,
        default: '',
        required: false
      },
      searchPageUrl: {
        type: String,
        required: true
      },
      searchString: {
        type: String,
        required: false,
        default: ''
      },
      autofocus: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      if (this.autofocus) {
        this.$refs.searchInput.focus()
      }
    },

    methods: {
      change: debounce(
        function ($event) {
          const ENTER_KEY_CODE = 13

          const string = $event.target.value.replace(/\s\s+/g, ' ').trim()
          const query = querystring.stringify({ search: string })

          if ($event.keyCode === ENTER_KEY_CODE) {
            if (query !== 'search=') {
              if (!this.resultsPageVisible) {
                window.open(this.searchPageUrl + `#${query}`, '_self')
              }
              this.$emit('close')
            }
          } else {
            this.$store.dispatch('search/setSearchString', string)

            if (this.resultsPageVisible) {
              window.location.hash = query
            }
          }
        }, 1000
      )
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .search-container.green {
    display: inline-block;
    position: relative;
    margin-left: 8px;
    width: 200px;

    @include bp-tablet-only {
      width: 170px;
    }

    @include bp-mobile {
      margin: 0;
      padding: 20px;
      width: 100%;
    }

    &:before {

      @include bp-mobile {
        content: $icon-search;
        @include icon-font();
        position: absolute;
        top: 22px;
        left: 36px;
        font-size: em(16);
        line-height: 40px;
        color: #858894;
      }
    }

    &:after {

      @include bp-mobile {
        @include mobile-menu-item-separator(20px, $blue-grey-dark);
      }
    }

    > input {
      padding: 0 36px 0 15px;
      width: 100%;
      height: 30px;
      background-color: #c2cc34;
      box-shadow: 0 2px 0 0 hexToRGBA(#000000, 0.05);
      font-size: em(12);

      @include bp-mobile {
        padding: 0 20px 0 44px;
        height: 40px;
        background-color: #33394c;
        box-shadow: none;
        color: hexToRGBA(#ffffff, 0.4);
      }

      @include input-placeholder() {
        color: rgba(25, 28, 93, 0.6);

        @include bp-mobile {
          color: $grey;
        }
      }

      &:focus {
        background-color: #ffffff;

        @include bp-mobile {
          color: $grey-default;
        }
      }
    }
  }

  .search-container.white {
    position: relative;
    padding-left: 32px;
    width: 100%;

    @include bp-tablet {
      padding: 0 0 0 36px;
      height: 58px;
    }

    &:before {
      content: $icon-search-thin;
      @include icon-font-thin();
      position: absolute;
      left: 0;
      font-size: em(20);
      line-height: 42px;
      color: $grey;
      pointer-events: none;

      @include bp-tablet {
        line-height: 58px;
        color: $gray-text-color;
      }
    }

    input {
      padding: 0;
      width: 100%;
      font-size: em(16);

      @include bp-tablet {
        height: 58px;
        background-color: transparent;
        font-size: em(14);
      }

      @include input-placeholder {
        color: rgba(39, 39, 39, 0.3);

        @include bp-tablet {
          color: $gray-text-color;
        }
      }
    }
  }

  .search-suggestions {
    z-index: 1;
    position: absolute;
    top: 50px;
    left: 0;
  }
</style>
